import { useEffect } from "react";
import { Container, Card, CardContent, CardHeader, Button } from "@kmf/ui";
import flowImage from "@/assets/flow-image.svg";
import flowImageMobile from "@/assets/flowImage-mobile.svg";

export function GuidePage() {
  useEffect(() => {
    document.title = "가이드 - KMF 할랄위원회";
  }, []);

  return (
    <div className="public-page py-12 md:py-16">
      <Container>
        {/* Page Header */}
        <div className="public-page-header">
          <h1 className="text-3xl font-bold text-foreground md:text-4xl">
            블록체인 기반 실시간 할랄인증 서비스
          </h1>
          <p className="mt-4 text-lg text-muted-foreground">
            투명하고 신뢰할 수 있는 할랄 인증 시스템
          </p>
        </div>

        <div className="content-column mx-auto max-w-4xl space-y-8">
          {/* Introduction */}
          <Card className="public-panel">
            <CardHeader>
              <h2 className="text-xl font-semibold">서비스 소개</h2>
            </CardHeader>
            <CardContent className="prose prose-slate max-w-none">
              <p>
                KMF 할랄위원회는 블록체인 기술을 활용하여 할랄 인증의
                투명성과 신뢰성을 한층 높인 실시간 인증 서비스를 제공합니다.
              </p>
              <p>
                모든 인증 정보가 블록체인에 기록되어 위변조가 불가능하며,
                소비자는 QR코드 스캔만으로 제품의 할랄 인증 상태를
                실시간으로 확인할 수 있습니다.
              </p>
            </CardContent>
          </Card>

          {/* Service Flow Diagram */}
          <Card className="public-panel">
            <CardHeader>
              <h2 className="text-xl font-semibold">서비스 흐름도</h2>
            </CardHeader>
            <CardContent>
              <img
                src={flowImage}
                alt="블록체인 할랄인증 서비스 흐름도"
                className="hidden w-full md:block"
              />
              <img
                src={flowImageMobile}
                alt="블록체인 할랄인증 서비스 흐름도"
                className="w-full md:hidden"
              />
            </CardContent>
          </Card>

          {/* Features */}
          <Card className="public-panel">
            <CardHeader>
              <h2 className="text-xl font-semibold">주요 기능</h2>
            </CardHeader>
            <CardContent>
              <div className="grid gap-6 md:grid-cols-2">
                {[
                  {
                    title: "실시간 인증 확인",
                    description: "QR코드 스캔으로 즉시 인증 상태 확인",
                  },
                  {
                    title: "위변조 방지",
                    description: "블록체인 기반 데이터 무결성 보장",
                  },
                  {
                    title: "투명한 이력 관리",
                    description: "인증 이력 전체 추적 가능",
                  },
                  {
                    title: "글로벌 호환",
                    description: "국제 할랄 기관 연동 지원",
                  },
                ].map((feature) => (
                  <div
                    key={feature.title}
                    className="public-item flex gap-4 rounded-lg border p-4"
                  >
                    <div>
                      <h3 className="font-semibold text-foreground">
                        {feature.title}
                      </h3>
                      <p className="mt-1 text-sm text-muted-foreground">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* How to Use */}
          <Card className="public-panel">
            <CardHeader>
              <h2 className="text-xl font-semibold">사용 방법</h2>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                {[
                  {
                    step: 1,
                    title: "제품의 QR코드 스캔",
                    description: "스마트폰 카메라로 제품에 부착된 QR코드를 스캔합니다.",
                  },
                  {
                    step: 2,
                    title: "인증 정보 확인",
                    description: "제품명, 인증 번호, 유효 기간 등 상세 정보를 확인합니다.",
                  },
                  {
                    step: 3,
                    title: "블록체인 검증",
                    description: "블록체인에 기록된 인증 정보와 대조하여 진위를 확인합니다.",
                  },
                ].map((item) => (
                  <div key={item.step} className="flex gap-4">
                    <div className="step-number flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-lg font-bold text-primary-foreground">
                      {item.step}
                    </div>
                    <div>
                      <h3 className="font-semibold text-foreground">
                        {item.title}
                      </h3>
                      <p className="mt-1 text-muted-foreground">
                        {item.description}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          {/* CTA */}
          <div className="text-center">
            <Button asChild size="lg"><a href="http://halal.koreaislam.org/KMFHALAL/Login" target="_blank" rel="noopener noreferrer">인증 서비스 시작하기</a></Button>
          </div>
        </div>
      </Container>
    </div>
  );
}
